import { Component } from 'react';
import noop from 'lodash/noop';

import { set, clear } from './resolver';
import type { EmbeddedProduct } from './types';

type Props = {
	embeddedProduct: EmbeddedProduct;
};

// eslint-disable-next-line jira/react/no-class-components
export default class EmbeddedProductUpdater extends Component<Props> {
	componentDidMount() {
		set(this.props.embeddedProduct).catch(noop);
	}

	componentWillUnmount() {
		clear().catch(noop);
	}

	render() {
		return null;
	}
}
